import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const StyledAnchor = styled.a`
  ${(props) => props.theme.typography.button}
  color: ${(props) => props.theme.colors.grayscale.gray0};
  text-decoration: none;

  &:hover {
    color: ${(props) => props.theme.colors.grayscale.black};
  }
`;

/**
 * Renders a standard anchor tag. If LinkWrapper passed, wrap the anchor element
 * with the LinkWrapper.
 * Useful with parent applications using Next.js or React Router.
 */
function Link(props) {
  const {
    LinkWrapper,
    href,
    children,
    target,
    id,
    prefetch,
    rel,
    ...otherProps
  } = props;
  const refAttrs =
    target === '_blank' ? { target, rel: 'noopener' } : { target };

  if (rel) {
    refAttrs.rel = rel;
  }

  return LinkWrapper ? (
    <LinkWrapper passHref prefetch={prefetch} href={href}>
      <StyledAnchor id={id} {...refAttrs} {...otherProps}>
        {children}
      </StyledAnchor>
    </LinkWrapper>
  ) : (
    <StyledAnchor id={id} href={href} {...otherProps} {...refAttrs}>
      {children}
    </StyledAnchor>
  );
}

Link.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  target: PropTypes.string,
  /**
   * Wrapper for Next.js Link or React Router Link
   */
  LinkWrapper: PropTypes.func,
  id: PropTypes.string,
  prefetch: PropTypes.bool,
  rel: PropTypes.string,
};

Link.defaultProps = {
  target: '_self',
  LinkWrapper: null,
  id: null,
  prefetch: false,
  rel: '',
};

/* @component */
export default Link;
